/* MXDVS footer sign-up, layout A (02.10.2026). Used by sections/mxdvs-footer-newsletter.liquid.
   Adds the "> mail:" prompt in front of the footer email field, puts the offer (the footer's Newsletter text)
   under the field and highlights the chosen words: they decode once when they scroll into view, then a glow
   runs smoothly from left to right over the letters, round after round. The footer's own sign-up script
   (stitches, errors, needle) is not touched; the stitches only start after the prompt.
   02.10.2026: no page reload. After the footer's tug on the thread, the address is sent in the background;
   on success the needle sews the line and the message appears, like before but without reloading.
   04.10.2026: works with Shopify's spam protection (hCaptcha), see sendInBackground.
   05.10.2026 (approved in the "Menu drawer + footer" demo):
   E1: "Enter" takes the size, colour and letter spacing of the country box's "Change" button (matchChange).
   E2: on phones the footer menus open one at a time; Discover starts open (oneMenuAtATime).
   Both live here because this section is on every page; sections/footer.liquid stays unchanged.
   06.10.2026: faster 10% email. Inside the send step (so only after Shopify's spam check has passed), the
   address is also sent straight to Klaviyo's Email List (list XdHuwg, single opt-in), once per address.
   Shopify's own send stays as backup; messages and the needle are unchanged.
   06.10.2026 (later): every sign-up also gets the Klaviyo profile property "MXDVS Signup Source" =
   footer-signup, in a separate small request, so the team can see where each subscriber signed up.
   07.10.2026: "Already registered", same rule as the newsletter window. An address that signed up in this browser
   (here or in the window, shared memory) gets the message without sending again; otherwise Shopify's "already
   taken" answer shows it. Text: setting "Message: already registered" in the MXDVS footer sign-up section.
   A successful sign-up is remembered, so the newsletter window does not open again for this visitor.
   08.10.2026: the sign-up goes to Klaviyo only (no Shopify form, so no hCaptcha badge), with a hidden trap field,
   a throwaway address block and at most 5 sign-ups per hour per device. Klaviyo's answer decides the message:
   the needle and the success text only after Klaviyo accepted the address, otherwise "Not sent". */
(function () {
  /* Klaviyo (06.10.2026): client requests (public key only, made for browsers). Never throw and never block
     the sign-up: if Klaviyo cannot be reached, Shopify's send still delivers the address as before.
     Two requests: the subscription (starts the welcome flow) and, separately, the profile property
     "MXDVS Signup Source" (never delays or breaks the first).
     08.10.2026: Klaviyo is now the only send; the subscription's answer decides success (klaviyoSubscribeChecked). */
  var KL_BASE = 'https://a.klaviyo.com/client/';
  var KL_KEY = 'UKxycP';
  var KL_REVISION = '2026-07-15';
  var KL_LIST = 'XdHuwg';
  var KL_SOURCE_PROP = 'MXDVS Signup Source';

  /* Shared with the newsletter window (assets/mxdvs-newsletter-popup.js) */
  var NL_LIST_KEY = 'mxnl_emails', NL_DONE_KEY = 'mxnl_subscribed';
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function knownEmails() { try { return JSON.parse(lsGet(NL_LIST_KEY)) || []; } catch (e) { return []; } }
  function isKnown(em) { return !!em && (knownEmails().indexOf(em) > -1 || lsGet(NL_DONE_KEY) === em); }
  function rememberEmail(em) {
    if (!em) return;
    var l = knownEmails();
    if (l.indexOf(em) < 0) { l.push(em); lsSet(NL_LIST_KEY, JSON.stringify(l.slice(-20))); }
    lsSet(NL_DONE_KEY, em);
  }
  function klPost(path, payload) {
    var body = JSON.stringify(payload);
    var go = function (keep) {
      return fetch(KL_BASE + path + '/?company_id=' + KL_KEY, { method: 'POST', keepalive: keep, headers: { 'Content-Type': 'application/vnd.api+json', 'revision': KL_REVISION }, body: body });
    };
    try {
      return go(true).catch(function () { return go(false); }).catch(function () {});
    } catch (e) { return Promise.resolve(); }
  }
  /* 08.10.2026: the subscription is the real send. Resolves true only when Klaviyo accepts it (202), false on any
     failure. The "MXDVS Signup Source" request goes out separately and never changes the result. */
  function klaviyoSubscribeChecked(email, source, sourceKey) {
    var body = JSON.stringify({ data: {
      type: 'subscription',
      attributes: {
        custom_source: source,
        profile: { data: { type: 'profile', attributes: {
          email: email,
          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
        } } }
      },
      relationships: { list: { data: { type: 'list', id: KL_LIST } } }
    } });
    var go = function (keep) {
      return fetch(KL_BASE + 'subscriptions/?company_id=' + KL_KEY, { method: 'POST', keepalive: keep, headers: { 'Content-Type': 'application/vnd.api+json', 'revision': KL_REVISION }, body: body });
    };
    var result;
    try {
      result = go(true).catch(function () { return go(false); })
        .then(function (r) { return !!(r && r.ok); }, function () { return false; });
    } catch (e) { result = Promise.resolve(false); }
    try {
      var props = {}; props[KL_SOURCE_PROP] = sourceKey;
      klPost('profiles', { data: { type: 'profile', attributes: { email: email, properties: props } } });
    } catch (e) {}
    return result;
  }

  /* Spam guards (08.10.2026), same logic as the newsletter window (assets/mxdvs-newsletter-popup.js):
     a hidden trap field (people never fill it), no throwaway addresses, at most 5 sign-up sends per hour per
     device (localStorage 'mxnl_log', shared with the window; a time is only logged when a send goes out). */
  var NL_LOG_KEY = 'mxnl_log', NL_LOG_MAX = 5, NL_LOG_SPAN = 3600000;
  var THROWAWAY = /@(?:[^@]*\.)?(mailinator|guerrillamail|guerrillamailblock|sharklasers|grr|10minutemail|tempmail|temp-mail|yopmail|trashmail|getnada|dispostable|maildrop|throwawaymail|fakeinbox|mintemail|mohmal|emailondeck|spamgourmet)\./i;
  function sendLog() {
    var now = Date.now(), l = [];
    try { l = JSON.parse(localStorage.getItem(NL_LOG_KEY)) || []; } catch (e) { l = []; }
    if (!Array.isArray(l)) l = [];
    return l.filter(function (t) { return typeof t === 'number' && now - t < NL_LOG_SPAN; });
  }
  function logSend() {
    var l = sendLog();
    l.push(Date.now());
    try { localStorage.setItem(NL_LOG_KEY, JSON.stringify(l)); } catch (e) {}
  }
  function spamGuard(email) {
    if (THROWAWAY.test(email)) return 'throwaway';
    if (sendLog().length >= NL_LOG_MAX) return 'limit';
    return '';
  }
  /* Already-registered check (09.10.2026, launch item 27): before subscribing, ask CR
     (admin.mxdvs.co/api/nl/status) whether the address is already subscribed in Klaviyo.
     name+anything@ is checked as name@. CR only reads; the sign-up itself stays here.
     No answer within 2.5 seconds, or any error: carry on with the sign-up as before. */
  var CR_STATUS = 'https://admin.mxdvs.co/api/nl/status';
  var CR_WAIT = 2500;
  function baseEmail(em) { var p = String(em || '').split('@'); return p.length === 2 ? p[0].split('+')[0] + '@' + p[1] : em; }
  function crRegistered(email, website) {
    return new Promise(function (resolve) {
      var done = false, ctrl = null;
      var end = function (v) { if (done) return; done = true; clearTimeout(t); if (ctrl) { try { ctrl.abort(); } catch (e) {} } resolve(v); };
      var t = setTimeout(function () { end(false); }, CR_WAIT);
      try {
        ctrl = window.AbortController ? new AbortController() : null;
        fetch(CR_STATUS, { method: 'POST', headers: { 'Content-Type': 'text/plain' }, body: JSON.stringify({ email: baseEmail(email), website: website || '' }), signal: ctrl ? ctrl.signal : undefined })
          .then(function (r) { return r && r.ok ? r.json() : null; })
          .then(function (j) { end(!!(j && j.ok === true && j.registered === true)); }, function () { end(false); });
      } catch (e) { end(false); }
    });
  }
  function trapValue(form) { var t = form && form.querySelector('input[name="website"][data-mx-email-skip]'); return t ? t.value : ''; }
  function trapFilled(form) {
    var t = form && form.querySelector('input[name="website"][data-mx-email-skip]');
    return !!(t && t.value);
  }
  /* Detach the form from Shopify once: no action and no form_type, so Shopify's hCaptcha never attaches.
     contact[tags] and contact[email] stay. Adds the hidden trap field. */
  function detachFromShopify(form) {
    if (!form || form.getAttribute('data-mx-klaviyo-only') === '1') return;
    form.removeAttribute('action');
    var drop = form.querySelectorAll('input[name="form_type"],input[name="utf8"]');
    for (var i = 0; i < drop.length; i++) drop[i].parentNode.removeChild(drop[i]);
    if (!form.querySelector('input[name="website"]')) {
      var trap = document.createElement('input');
      trap.type = 'text';
      trap.name = 'website';
      trap.tabIndex = -1;
      trap.setAttribute('tabindex', '-1');
      trap.setAttribute('autocomplete', 'off');
      trap.setAttribute('aria-hidden', 'true');
      trap.setAttribute('data-mx-email-skip', '');
      trap.setAttribute('style', 'position:absolute;left:-9999px;width:1px;height:1px;opacity:0');
      form.appendChild(trap);
    }
    form.setAttribute('data-mx-klaviyo-only', '1');
  }

  function init() {
    var cfg = document.querySelector('[data-mxfn]');
    var thread = document.querySelector('footer.footer [data-ft-thread]');
    if (!cfg || !thread || thread.classList.contains('ft-nl-a')) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    thread.classList.add('ft-nl-a');
    sendInBackground(thread);
    matchChange(thread);

    /* Prompt in front of the field */
    var row = thread.querySelector('.ft-thread__row');
    var prompt = cfg.getAttribute('data-prompt') || '';
    if (row && prompt) {
      var pr = document.createElement('span');
      pr.className = 'ft-nl-pr';
      pr.setAttribute('aria-hidden', 'true');
      pr.textContent = prompt;
      row.insertBefore(pr, row.firstChild);
      var setPr = function () { thread.style.setProperty('--ft-nl-pr', (pr.offsetWidth + 8.5) + 'px'); };
      setPr();
      window.addEventListener('resize', setPr);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(setPr);
    }

    /* The offer under the field: the footer's own Newsletter text */
    var src = document.querySelector('footer.footer .footer__newsletter-text');
    if (!src || !src.textContent.trim()) return;
    var offer = document.createElement('p');
    offer.className = 'ft-nl-offer';
    offer.innerHTML = src.innerHTML;
    offer.style.setProperty('--ft-nl-speed', (parseInt(cfg.getAttribute('data-speed'), 10) || 2800) + 'ms');
    thread.parentNode.insertBefore(offer, thread.nextSibling);

    /* Wrap the words to highlight (first match, capitals ignored) */
    var words = (cfg.getAttribute('data-highlight') || '').trim();
    if (!words) return;
    var walker = document.createTreeWalker(offer, NodeFilter.SHOW_TEXT), node, el = null;
    while ((node = walker.nextNode())) {
      var at = node.nodeValue.toLowerCase().indexOf(words.toLowerCase());
      if (at < 0) continue;
      var hit = node.splitText(at);
      hit.splitText(words.length);
      el = document.createElement('span');
      el.className = 'ft-nl-hl';
      hit.parentNode.replaceChild(el, hit);
      el.appendChild(hit);
      break;
    }
    if (!el) return;
    var text = el.textContent;
    var esc = function (c) { return c === ' ' ? '&nbsp;' : c.replace(/[&<>]/g, function (x) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[x]; }); };
    var wave = function () {
      el.style.minWidth = '';
      el.innerHTML = text.split('').map(function (c, i) { return '<i style="--i:' + i + '">' + esc(c) + '</i>'; }).join('');
      el.style.setProperty('--n', text.length);
      el.classList.add('is-wave');
    };
    if (reduce || !('IntersectionObserver' in window)) return;
    var G = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789%#';
    el.style.minWidth = el.offsetWidth + 'px';
    el.textContent = text.replace(/[^ ]/g, '#');
    var io = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return;
      io.disconnect();
      var t0 = performance.now();
      (function f(now) {
        var k = Math.min(1, (now - t0) / 900), o = '';
        for (var i = 0; i < text.length; i++) o += (text[i] === ' ' || i < k * text.length) ? text[i] : G[(Math.random() * G.length) | 0];
        el.textContent = o;
        if (k < 1) requestAnimationFrame(f); else wave();
      })(t0);
    }, { threshold: 1 });
    io.observe(el);
  }

  /* E1 (05.10.2026): "Enter" copies the size, colour and letter spacing of the country box's "Change" button.
     The CSS (assets/mxdvs-footer-newsletter.css) already sets the same values; this keeps them equal if the
     country box ever changes. Without a country box, the CSS values stay. */
  function matchChange(thread) {
    var change = document.querySelector('footer.footer .ft-board__toggle');
    if (!change) return;
    var cs = getComputedStyle(change);
    thread.style.setProperty('--ft-nl-btn-size', cs.fontSize);
    thread.style.setProperty('--ft-nl-btn-ls', cs.letterSpacing === 'normal' ? '0' : cs.letterSpacing);
    thread.style.setProperty('--ft-nl-btn-color', cs.color);
  }

  /* E2 (05.10.2026): phones (below 750px) show one footer menu at a time. Discover is the first menu and starts
     open (sections/footer.liquid). Tapping a closed menu first closes the open one, through the footer's own
     click handler, so it slides shut exactly like a tap on it. Desktop keeps all three menus open. */
  function oneMenuAtATime() {
    if (window.__mxfnOneMenu) return;
    window.__mxfnOneMenu = true;
    var desktop = window.matchMedia('(min-width: 750px)');
    document.addEventListener('click', function (event) {
      if (desktop.matches || event.target.closest('a')) return;
      var summary = event.target.closest('footer.footer .footer__blocks summary.footer-accordion__summary');
      if (!summary) return;
      var details = summary.parentElement;
      if (!details.classList.contains('footer-accordion--desktop-open') || details.classList.contains('is-expanded')) return;
      var footer = details.closest('footer.footer');
      var open = footer.querySelectorAll('.footer__blocks details.footer-accordion--desktop-open.is-expanded');
      for (var i = 0; i < open.length; i++) {
        if (open[i] === details) continue;
        var other = open[i].querySelector(':scope > summary.footer-accordion__summary');
        if (other) other.click();
      }
    }, true);
  }

  /* Send without a page reload. The footer script first checks the address and tugs the thread, then submits
     again; that second submit is caught here and sent to Klaviyo instead.
     08.10.2026: Klaviyo only. The form is detached from Shopify (detachFromShopify), so Shopify's hCaptcha never
     attaches and nothing is sent to Shopify. Klaviyo's answer decides: success text and needle, or "Not sent".
     Spam guards first: trap field (fake success, nothing sent), throwaway addresses, 5 sends per hour per device. */
  function sendInBackground(thread) {
    var form = thread.closest('form');
    if (!form || form.dataset.mxfnAjax) return;
    form.dataset.mxfnAjax = '1';
    detachFromShopify(form);
    var cfg = document.querySelector('[data-mxfn]');
    var existsText = (cfg && cfg.getAttribute('data-exists')) || 'Already registered. Your 10% code was sent when you first subscribed. Check your spam folder too.';
    var successText = (cfg && cfg.getAttribute('data-success')) || 'Welcome in. Check your inbox for your 10% code.';
    var sent = false, busy = false;
    var showFail = function (msg) {
      if (sent || thread.getAttribute('data-state') === 'success') return;
      thread.classList.remove('is-sending');
      thread.classList.add('is-error');
      var out = thread.querySelector('[data-thread-error]'), txt = thread.querySelector('[data-thread-error-text]');
      if (txt) txt.textContent = msg;
      if (out) out.hidden = false;
    };
    /* The line under the field after sending: the success text, or "Already registered" (07.10.2026) */
    var showDone = function (text, exists) {
      var done = thread.querySelector('.ft-thread__done');
      if (!done) {
        done = document.createElement('p');
        done.className = 'ft-thread__done';
        done.id = 'ContactFooter-success';
        done.tabIndex = -1;
        done.setAttribute('role', 'status');
        var entry = thread.querySelector('.ft-thread__entry');
        entry.parentNode.insertBefore(done, entry.nextSibling);
      }
      done.textContent = text;
      sent = true;
      var errOut = thread.querySelector('[data-thread-error]');
      if (errOut) errOut.hidden = true;
      thread.classList.remove('is-sending', 'is-focus', 'is-error');
      thread.classList.toggle('is-exists', !!exists);
      thread.setAttribute('data-state', 'success');
      void thread.offsetWidth;
      thread.classList.add('is-sewing');
      try { done.focus({ preventScroll: true }); } catch (err) {}
    };
    var send = function () {
      if (sent || busy) return;
      var emailField = form.querySelector('input[name="contact[email]"]') || form.querySelector('input[type="email"]');
      var email = String((emailField && emailField.value) || '').trim().toLowerCase();
      /* Signed up before in this browser (here or in the newsletter window): no second sign-up */
      if (isKnown(email)) { showDone(existsText, true); return; }
      /* Trap field filled: looks like a success, nothing is sent */
      if (trapFilled(form)) { showDone(successText, false); return; }
      var guard = spamGuard(email);
      if (guard === 'throwaway') { showFail('Use your own email address, not a throwaway one.'); return; }
      if (guard === 'limit') { showFail('Too many sign-ups from this device. Try again in an hour.'); return; }
      busy = true;
      /* 09.10.2026: already subscribed in Klaviyo (any device): Already registered, nothing sent */
      crRegistered(email, trapValue(form)).then(function (reg) {
        if (reg) { busy = false; rememberEmail(email); showDone(existsText, true); return; }
        logSend();
        klaviyoSubscribeChecked(email, 'MXDVS footer sign-up', 'footer-signup').then(function (ok) {
          busy = false;
          if (ok) {
            rememberEmail(email);
            showDone(successText, false);
          } else {
            showFail('Not sent. Check your connection and try again.');
          }
        });
      });
    };
    /* Any code that calls form.submit() still lands here */
    form.submit = function () { send(); };
    form.addEventListener('submit', function (e) {
      if (e.defaultPrevented) return; /* the footer's first submit: it checks the address and tugs the thread */
      e.preventDefault(); /* never a native send: the page never navigates */
      if (thread.classList.contains('is-sending')) { send(); return; }
      /* A new try after an error: the footer's script lets it through, so send it from here */
      if (sent || busy || thread.getAttribute('data-state') === 'success') return;
      var field = form.querySelector('input[name="contact[email]"]');
      if (!field || !field.value.trim() || (field.checkValidity && !field.checkValidity())) return;
      var errOut = thread.querySelector('[data-thread-error]');
      if (errOut) errOut.hidden = true;
      thread.classList.remove('is-error');
      thread.classList.add('is-sending');
      send();
    });
  }

  oneMenuAtATime();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();